module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/oee_2-1c3c2bdc2be4b715ace92644fdd3997d.png";